<template>
  <CRow class="balances pt-4" :gutters="false">
    <CCol
      class="balances__item mb-1"
      :class="{ 'balances__item--list': columns.list }"
      :sm="columns.qnt"
      v-for="(ItemBalance, index) in balances"
      :key="`${ItemBalance.channel}-${index}`"
    >
      <div>
        <input
          :ref="`ref-${ItemBalance.channel}`"
          type="radio"
          :show="false"
          class="balances__radio"
          name="channel"
          v-model="channelValue"
          :id="ItemBalance.channel"
          :value="ItemBalance.channel"
        />
        <label class="balances__box m-0" name="channel" :for="ItemBalance.channel" @click.stop="getValueChannel(ItemBalance.channel)">
          <div class="d-flex">
            <CIcon :name="ItemBalance.channel" class="text-gray-600" size="custom-size" label="teste" :height="25" viewBox="0 0 32 32" />
            <p class="text-uppercase mb-0 font-md ml-2">
              {{ $t(`home.campaignSumary.${ItemBalance.channel}-available`) }}
            </p>
          </div>
          <p class="font-4xl font-weight-light mt-3">
            {{ numberWithCommas(ItemBalance.currentBalance) }}
          </p>
        </label>
      </div>
    </CCol>
  </CRow>
</template>

<script>
const channelTypeCode = {
  1: 'email',
  2: 'sms',
}
export default {
  name: 'balance',
  props: {
    balances: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: () => 1,
    },
    list: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      channelTypeCode,
      channelValue: this.value,
    }
  },

  mounted() {
    setTimeout(() => {
      if (this.$refs['ref-email'][0]) this.$refs['ref-email'][0].checked = true
    }, 1000)
  },

  computed: {
    columns() {
      return this.list ? { qnt: 12, list: true } : { qnt: 6, list: false }
    },
  },

  methods: {
    getValueChannel(channel) {
      this.$emit('channelSelected', channel)
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
  },
}
</script>

<style lang="scss" scoped>
.balances {
  &__item {
    display: flex;
    justify-content: center;
    & > div {
      background: var(--white);
      width: 100%;
    }
    &--list {
      .balances__radio {
        display: none !important;

        &:checked + {
          .balances__box {
            border: 1px solid var(--primary);
            color: var(--gray-600);
          }
        }
      }
      .balances__box {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        background: var(--white);
        border: 1px solid var(--white);
        color: var(--gray-400);
      }
    }
  }
}
</style>
